export const
    COMPANY_ERROR= 'COMPANY_ERROR',
    COMPLAINT_ERROR = 'COMPLAINT_ERROR',
    COMPLAINT_POSITION_ERROR = 'COMPLAINT_POSITION_ERROR',
    CUSTOMER_ERROR = 'CUSTOMER_ERROR',
    UTIL_ERROR = 'UTIL_ERROR';



// WEBPACK FOOTER //
// ./src/const/ErrorPlace.js